import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'loop',
  name: 'Loop',
  category: 'flow-control',
  description: 'Iterate over items',
  icon: 'Repeat',
  color: 'amber',
  version: '1.0.0',
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'loop',
      type: 'main',
      displayName: 'Loop',
    },
    {
      name: 'done',
      type: 'main',
      displayName: 'Done',
    },
  ],
};

export default definition;
